import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { BomModelByReferencePipe } from './bom-model-by-reference.pipe';

@Pipe({
    name: 'existingAdditionalComponentsQuantityInCatalogue',
    standalone: false
})
export class ExistingAdditionalComponentsQuantityInCataloguePipe implements PipeTransform {

  transform(existingProductInBom: IBomModel, existingProductsAlreadyInCatalogue: IBomModel[]): number {
    // eslint-disable-next-line max-len
    const currentCatalogueQuantity = new BomModelByReferencePipe().transform(existingProductsAlreadyInCatalogue, existingProductInBom?.article?.ref)?.quantity;

    return  currentCatalogueQuantity > -1 ? currentCatalogueQuantity : existingProductInBom?.quantity;
  }

}
